import { makeStyles, createStyles } from '../../../styles';
export default makeStyles((theme) => createStyles({
    root: {},
    selected: {
        backgroundColor: theme.palette.action.selected,
    },
}));
//# sourceMappingURL=ActionBarSelectOption.styles.js.map